import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useSelector } from 'react-redux';

//import images
import { Link } from 'react-router-dom';
import { RootState } from 'store';
import Avatar from 'react-avatar';
import AgencyDropdown from './AgencyDropdown';
import PerfectScrollbar from 'react-perfect-scrollbar'
import NichesIcon from 'assets/icons/NichesIcon';
import NotificationIcon from 'assets/icons/mono/NotificationIcon';

const HeaderNotificationDropdown = () => {

    const user = useSelector((state: RootState) => state.auth.user);

    const notifications: {
        title: string,
        campaign: string,
        time: string
    }[] = [];

    //Dropdown Toggle
    const [isNotificationDropdown, setNotificationDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setNotificationDropdown(!isNotificationDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isNotificationDropdown} toggle={toggleProfileDropdown} direction='down' className="">
                <DropdownToggle tag="button" type="button" className="btn p-0">
                    <span className="d-flex align-items-center notification-dropdown-btn">
                        <NotificationIcon />
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end notifications-dropdown mt-1">
                    <PerfectScrollbar>
                        <div className="p-3 py-0">
                            <h6 className='notification-dropdown-heading m-0 pt-3'>Notification</h6>
                            <div className="notifications">
                                {
                                    notifications.map((notification, i) => {
                                        return (
                                            <div className='notification my-3 d-flex align-items-center gap-2 justify-content-between cursor-pointer' key={i}>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className="notification-icon">
                                                        <NichesIcon className />
                                                    </span>
                                                    <div className="d-flex flex-column gap-1">
                                                        <span className="notification-title">{notification.title}</span>
                                                        <span className="notification-campaign">{notification.campaign}</span>
                                                    </div>
                                                </div>
                                                <span className="notification-time">{notification.time}</span>
                                            </div>
                                        )
                                    })
                                }
                                {
                                    notifications.length === 0 &&
                                    <div className='w-100 no-notifications d-flex justify-content-center align-items-center'>No notifications!</div>
                                }
                            </div>
                        </div>
                    </PerfectScrollbar>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default HeaderNotificationDropdown;